import axios from 'axios';
import store from '@/store';
import Vue from 'vue';
import { 
  SESSION_TIMEOUT_MESSAGE, 
  START_LOGIN_MESSAGE,
  OK,
  ERROR,
  TIMEOUT,
  NOTLOGGEDIN
} from './ajaxActionResponse';
import { post } from '@/store/modules/fsm/index';
import { LogoutRequest } from '@/store/modules/fsm/messages';
import { RESET_TIMER } from '@/constants/event';

let callLevel = 0;
let timedOut = false;
export const inRequest = () => callLevel > 0;

/**
 * This function serves as gateway - 
 * all request and response will go through here
 * 
 * @param {Object} config 
 */
export async function request(config) {
  if(timedOut)
    return;
  preRequestProcessing();
//  let csrf = store.getters['login/getCsrf'];
//  if(csrf && config.data)
 //   config.data = { ...config.data,[csrf.param] : csrf.token };
    let data,response;
    try {
      callLevel++;
      response = await axios.request(config);
      callLevel--;
      if(response === undefined)
      {
        return;
      }
      data = response.data;
    }
    catch(err) {
      callLevel--;
      throw err;
    }
    store.dispatch('login/updateCsrf',data.csrf);
    //TODO: all reponse.data will have {data, status, message}
    if (response && data) {
      if (data.message === SESSION_TIMEOUT_MESSAGE || data.status === TIMEOUT) {
        if(timedOut)
          return;
        timedOut = true;
        post({message: LogoutRequest});
        alert('Session timed out');
        location.path = '/';
        location.reload();
      } else if (data.message === START_LOGIN_MESSAGE || data.status === NOTLOGGEDIN) {
        /* 
          dispatch a resetSession action
          because when session times out 
          while app data is still present,
          layout is still private, which keeps a navigation bar
        */
        store.dispatch('login/resetSession');
 
      } else {
        postRequestProcessing({config});
      }

      // TODO: verify this approach
      if (data.status === ERROR) {
        throw data.message;
      }
    }
    return response;
  
}

function preRequestProcessing(reqParams) {
  // TODO: 
}

function postRequestProcessing(info) {
  let action = info.config.data.action;
  let ping = action !== 'ping' && action !== 'saveState';
  Vue.vueEventBus.$emit(RESET_TIMER,{ping});
}
